module.exports = __webpack_public_path__ + "img/icn_radio_on.e65fde63.svg";